<template>
  <div class="is-main-content">
    <div>
      <div class="container is-fluid">
        <div class="level">
          <div class="level-left">
            <a href="javascript:history.back()">
              <div class="field is-horizontal">
                <div class="align-center">
                  <b-icon icon="arrow-left" type="is-primary"></b-icon>
                </div>
                <div class="field">
                  <span class="subtitle level" style="margin-left:20px;">
                    Retour
                  </span>
                </div>
              </div>
            </a>
          </div>
          <div class="level-right">
            <b-button type="is-primary" v-if="isAffixe2" @click="openPopUpUpdateClient">
              Modifier
            </b-button>
          </div>
        </div>
      </div>
      <hr>
      <br>
      <div class="container is-fluid">
        <b-tabs type="is-toggle">
          <b-tab-item label="Information" icon="information-variant">
            <app-information/>
          </b-tab-item>
          <b-tab-item label="Historique"  icon="history">
            <app-historique :cliNum="num"/>
          </b-tab-item>
        </b-tabs>
      </div>
    </div>
    <b-modal v-model="openPopUpUpdate"
               has-modal-card
               class="modal">
      <app-modifier-client
          :client="clientAModifier"
          @update="rechercheDetailClient(num)"
          @close="openPopUpUpdate = false">
      </app-modifier-client>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { browseDetailClient } from '@/api/clients/index';
import * as types from '@/store/modules/client-mutation-type';
import adresseGeoCoder from '@/services/general/adresseGeoCoder';
import modifierClient from '@/components/clientProspect/ficheClient/modifierClient';
import preparationClientToUpdate from '@/services/client/preparationClientToUpdate';
import information from './information/index';
import historique from './historique/index';

const Client = createNamespacedHelpers('client');
const Parametrages = createNamespacedHelpers('parametrage');

export default {
  name: 'index',
  data() {
    return {
      num: '',
      openPopUpUpdate: false,
      clientAModifier: null,
    };
  },
  components: {
    appInformation: information,
    appHistorique: historique,
    appModifierClient: modifierClient,
  },
  computed: {
    ...Client.mapGetters({
      getClient: 'client',
    }),
    client: {
      get() {
        return this.getClient;
      },
      set(value) {
        this.setClient(value);
      },
    },
    ...Parametrages.mapGetters({
      isAffixe2: 'affixe2',
    }),
  },
  methods: {
    ...Client.mapMutations({
      setClient: types.SET_CLIENT,
    }),
    ...Client.mapActions({
      actionsRechercheCommandesByClient: 'rechercheCommandesByClient',
    }),
    async rechercheDetailClient(cliNum) {
      const response = await browseDetailClient(cliNum);
      await this.actionsRechercheCommandesByClient({ cliNum: cliNum });
      if (response.data.latitude && response.data.longitude) {
        response.data.position = { lat: response.data.latitude, lng: response.data.longitude };
        this.client = response.data;
        return;
      }
      const address = response.data.adrLibelle1 + ' ' +
        response.data.adrCp + ' ' +
        response.data.adrVille;
      adresseGeoCoder(address).then((position) => {
        response.data.position = position;
        this.client = response.data;
      }).catch(() => {
        this.client = response.data;
      });
    },
    openPopUpUpdateClient() {
      this.openPopUpUpdate = true;
      this.clientAModifier = preparationClientToUpdate(this.client);
    },
  },
  mounted() {
    this.num = this.$route.params.num;
    const loadingComponent = this.$buefy.loading.open({ container: null });
    this.rechercheDetailClient(this.num).then(() => {
      loadingComponent.close();
    });
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/clientProspect/ficheClient/index.vue